<template>
	<div 
		id="breadcrumbs" 
		v-if="$store.getters.breadcrumb_count > 0" 
		class="d-print-none"
	>
		<div style="overflow: hidden">
			<v-breadcrumbs 
				small
				dark
				class="py-1 breadcrumbs-left"
				:items="breadcrumbs_local"
				divider=">"
			>
				<template 
					v-slot:item="{ item }"
				>
					<v-breadcrumbs-item
						:to="item.to"
						:disabled="item.disabled"						
					>
						<span class="breadcrumbs-item-text">
							{{ item.text }}
						</span>
					</v-breadcrumbs-item>
				</template>
			</v-breadcrumbs>
		</div>
		<div style="clear: right"/>
	</div>
</template>

<script>

export default {
	data() {
		return {}
	},
	computed: {
		breadcrumbs() {
			return this.$store.state.breadcrumbs;
		},
		breadcrumbs_local() {
			const width = this.$vuetify.breakpoint.width;

			if (width < 860) {
				return this.breadcrumbs.slice(this.breadcrumbs.length - 1);
			} else if(width < 985) {
				return this.breadcrumbs.slice(this.breadcrumbs.length - 2);
			} else if(width < 1080) {
				return this.breadcrumbs.slice(this.breadcrumbs.length - 3);
			} else {
				return this.breadcrumbs;
			}
		},
	},
	methods: {
		close_last() {
			// remove the top entry
			this.$store.commit("pop_breadcrumb");

			// get our now top entry
			let breadcrumb = this.$store.getters.get_last_breadcrumb;
			if (breadcrumb != null) {
				// if we have it, go to it
				this.$router.push(breadcrumb.to);
			} else {
				// if we cleared our breadcrumbs go to our current root
				this.$router.push(this.$route.matched[0].path);
			}
		}
	}
}
</script>

<style lang="scss" scoped>
#breadcrumbs {
	background-color: #192a3e;
	position: relative;
	width: 100%;
}
.breadcrumbs-item-text {
	color: #FFFFFF;
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 21px;
	white-space : nowrap
}

.breadcrumbs-left {
	padding-left: 4px
}

::v-deep {
	.theme--dark.v-breadcrumbs .v-breadcrumbs__divider, 
	.theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled  {
		color: #FFFFFF;
		font-family: Roboto;
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 21px;
	}

	.v-application ul, .v-application ol {
		padding-left: 4px;
	}
}
</style>
